import {
    Popover,
    Typography,
    List,
    ListItem,
    Divider,
    Stack,
    IconButton
} from "@mui/material";
import { surveillanceMap } from "./surveillanceMap";
import React from "react";
import ClearIcon from "../../assets/icons/ClearIcon";
import AlertIcon from "../../assets/icons/AlertIcon";

interface SurveillanceInfo {
    symbol: string;
    warningTitle: string;
    cautions: string[];
}

interface SurveillancePopoverProps {
    anchorEl: null | HTMLElement;
    open:boolean
    info: SurveillanceInfo;
    onClose: () => void;
}

export const PopUpPopover = ({
    anchorEl,
    info,
    onClose,
    open
}: SurveillancePopoverProps) => {
   return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            PaperProps={{
                sx: { maxWidth: 360,  mt: -2,},
                 
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} p={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <AlertIcon/>
                    <Typography variant="body2" sx={{textAlign: 'justify'}}>Regulatory caution</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={onClose}>
                        <ClearIcon style={{ fontSize: '12px' }} />
                    </IconButton>
                </Stack>
            </Stack>
            <Divider sx={{ mb: 1 }} />
            <Typography fontSize={'13px'} sx={{ mb: 0.3 , textAlign: 'justify', lineHeight: 1.5   }} pl={1} pr={1} >
                {info.symbol} has the following cautionary messages –
            </Typography>
            <List dense sx={{ pl: 3 }}>
                {info.cautions.map((codeStr: string, i: number) => {
                    const code = Number(codeStr);
                    const [label, message] = surveillanceMap[code] ?? [];

                    return (
                        <React.Fragment key={i}>
                            <ListItem
                                sx={{
                                    display: 'list-item',
                                    listStyleType: 'disc',
                                    pl: 1,
                                    py: 0,
                                    pb: 1
                                }}
                            >
                                <Typography  fontSize={'12px'} component="span">
                                    {label ?? `Surveillance Code (${code})`}
                                </Typography>
                            </ListItem>

                            {message && (
                                <ListItem
                                    sx={{
                                        display: 'list-item',
                                        listStyleType: 'disc',
                                        pl: 1,
                                        py: 0,
                                    }}
                                >
                                    <Typography  fontSize={'12px'} component="span">
                                        {message}
                                    </Typography>
                                </ListItem>
                            )}
                        </React.Fragment>
                    );
                })}
            </List>
            <Typography fontSize={'12px'} p={1} sx={{textAlign: 'justify',}}>
                Please analyse the risks carefully before proceeding.
            </Typography>
        </Popover>
    );
};
